export default "__VITE_ASSET__Cc4wY3GP__"